// Simple pubsub
let sub = {};
window.subscribe = (e, fn) => { (sub[e] = sub[e] || []).push(fn); return () => { sub[e] = sub[e].filter(s => s !== fn); }; };
window.publish = (e, d) => (sub[e] || []).forEach(fn => fn(d));
